<template>
	<div class="cotent_con">
		<div class="content_top">
			<img src="@/assets/images/contact/banner.jpg" alt="" class="w100">
			<!-- <h3>Contact Us</h3> -->
		</div>
		<div class="content_center">
			<div class="container">
				<h3>Справка & контакты</h3>
				<div class="text_nr_box">
					<ul>
						<li>
							<img src="@/assets/images/contact/icon_1.png" alt="" />
							<div class="text_box">
								<h4>Название компании: HISAN (Tianjin) Co., Ltd</h4>
							</div>
						</li>
						<li>
							<img src="@/assets/images/contact/icon_2.png" alt="" />
							<div class="text_box">
								<h4>Электронная почта: HS@Hisantech.com</h4>
								
							</div>
						</li>
						<li>
							<img src="@/assets/images/contact/icon_3.png" alt="" />
							<div class="text_box">
								<h4>Телефон: +86 22 84776558</h4>
								
							</div>
						</li>
					    <li>
							<img src="@/assets/images/contact/icon_4.png" alt="" />
							<div class="text_box">
								<h4>Адрес: NO.3, XinGang Wuhao Road, JinNan District,TianJin,China</h4>
								
							</div>
						</li>
					
					
					</ul>	
					<img src="@/assets/images/contact/img1.jpg" alt="" class="img1"/>
				</div>	
                <h4>Настройте свои износостойкие решения  прямо сейчас.</h4>
			</div>
			
		</div>
		<div class="content_bottom">
			<div class="container">
				<h3>Запросить цену</h3>
				<ul class="input_box">
					<li>
						<p>Имя<span>*</span></p>
						<input type="text" v-model="name"/>
					</li>
					<li>
						<p>Электронная почта<span>*</span></p>
						<input type="text" v-model="email"/>
					</li>
					<li>
						<p>Телефон<span>*</span></p>
						<input type="text" v-model="phone" />
					</li>
					<li>
						<p>Наименование компании<span>*</span></p>
						<input type="text" v-model="company"/>
					</li>
				</ul>
				<div class="checkbox_box">
					<p>Интересующие вас продукции</p>
					<ul>
						<li>
							<input type="checkbox" value="Плиты биметаллические износостойкие" v-model.number="interest" name="interest" id="" />
							 Плиты биметаллические износостойкие</li>
						<li>
							<input type="checkbox" value="Абразивостойкие стальные плиты" v-model.number="interest" name="interest" id="" />
							 Абразивостойкие стальные плиты</li>
						<li><input type="checkbox" value="Износостойкие трубы с наплавкой" v-model.number="interest" name="interest" id="" /> Износостойкие трубы с наплавкой</li>
						
					</ul>
					<ul>
					    <li><input type="checkbox" value="Высокохромистый белый чугун" v-model.number="interest" name="interest" id="" /> Высокохромистый белый чугун</li>
					    <li><input type="checkbox" value="Износостойкие керамические плиты" v-model.number="interest" name="interest" id="" /> Износостойкие керамические плиты</li>
					    <li><input type="checkbox" value="Износостойкие порошковые проволоки" v-model.number="interest" name="interest" id="" /> Износостойкие порошковые проволоки</li>
					</ul>
				</div>
				<div class="message_box">
					<p>Сообщение</p>
					<textarea name="" v-model="message" id="message"></textarea>
				</div>
				<div class="button_submit" @click="submitinfo()">
					Отправить
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	import axios from 'axios';
	
	export default {
		data() {
			return {
				name:'',
				email:'',
				phone:'',
				company:'',
				interest:[],
				message:'',
			}
		},
		methods:{
			submitinfo(){
				console.log(this.interest)
				if(this.email==''){
					alert("Enter your email address")
				}else if(this.name==''){
					alert("Enter your name")
				}else if(this.phone==''){
					alert("Enter your phone")
				}else if(this.company==''){
					alert("Enter your company")
				}else{
					console.log(this.useremail)
					axios({
						method: 'post',
						url:`${this.$apiYf}/liuyanapi.php`,
						data: {
							email:this.email,
							name:this.name,
							phone:this.phone,
							company:this.company,
							interest:this.interest.toString(),
							message:this.message,
						},
						headers: {'Content-Type': 'multipart/form-data'},
					}).then((res) =>{
						console.log(res)
					    alert(res.data.des)
					})
					
				}
			}
		}
	}
</script>

<style scoped lang="scss">
    .cotent_con{
        .content_center{
        	width:100%;
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
            h4{color: #0c4fa2;font-size: 24px;margin-bottom:10px;}
            @media (max-width: 1400px) {
               h4{font-size: 20px;}
               p{font-size: 14px;line-height: 2;}
            }
        	.text_nr_box{
        		display: flex;align-items: flex-start;
        		ul{
        			flex: 1;
        			li{display: flex;align-items: center;margin-bottom: 3vw;
        				img{background: #0c4fa2;margin-right: 10px;}
        				
        				p{font-size: 18px;color: #333;}
        				
        			}
        		}
        		.img1{
        			width: 41.428%;
        		}
        		
        		
        		
        	}
        	
        }
        .content_bottom{
        	position: relative;
        	
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	p{font-size: 18px;color: #333333;font-weight: bold;
        		span{color:#d30000;}
        	}
        	.input_box{
        		display: flex;justify-content: space-between;flex-wrap: wrap;
        		li{width: 48%;margin-bottom: 2vw;
        			input{width: 100%;background: #efefef;border: none;outline: none;padding:0 1%;height: 50px;line-height: 50px;
        				&:focus{
        					border: solid 1px #0c4fa2;
        				}
        			}
        		}
        	}
        	.checkbox_box{
        		ul{
        			display: flex;margin-bottom: 0.5vw;justify-content: space-between;font-size: 16px;color: #333;
                    li{width: 33%;}
        		}
        	}
        	.message_box{
                margin-top: 2vw;
        		textarea{width: 100%;background:#efefef;height: 100px;border: none;outline: none;
        			padding: 1%;
        			&:focus{
        				border: solid 1px #0c4fa2;
        			}
        		}
        	}
        	.button_submit{font-size: 24px;color: #fff;line-height: 50px;height: 50px;width: 100%;text-align: center;background: #0c4fa2;margin: 2vw 0 4vw;}
        }
        
    }
	
</style>